import { Reducer } from 'redux';
import { AbandonedCartData, AbandonedCartState, Types } from './types';

const INITIAL_STATE: AbandonedCartState = {
  data: null,
  dismissed: false
};

type TCustomAction =
  | { type: Types.SET_ABANDONED_CART; payload: { data: AbandonedCartData } }
  | { type: Types.CLEAR_ABANDONED_CART; payload: Record<string, never> }
  | { type: Types.SET_DISMISSED; payload: Record<string, never> };

const reducer: Reducer<AbandonedCartState, TCustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.SET_ABANDONED_CART:
      return {
        ...state,
        data: action.payload.data
      };
    case Types.CLEAR_ABANDONED_CART:
      return {
        ...INITIAL_STATE
      };
    case Types.SET_DISMISSED:
      return {
        ...state,
        dismissed: true
      };
    default:
      return state;
  }
};

export const setAbandonedCart = (data: AbandonedCartData) => ({
  type: Types.SET_ABANDONED_CART,
  payload: { data }
});

export const clearAbandonedCart = () => ({
  type: Types.CLEAR_ABANDONED_CART,
  payload: {}
});

export const setDismissed = () => ({
  type: Types.SET_DISMISSED,
  payload: {}
});

export const fetchAbandonedCart = (bps: string[]) => ({
  type: Types.FETCH_ABANDONED_CART,
  payload: { bps }
});

export default reducer;
